import ApiCaller from "@/services/ApiCaller/apiCallerDefault";
import {getUserIdFromCookie} from "@/utils/responsive/utils";
import {CartItem} from "@/models/scope/cart/CartItem";
import {ThunkResult} from "@/models/common/core/ThunkResult";
import {SHIPPING_CART_ITEMS_UPDATE_TYPES} from "@/redux/reducers/responsive/shipping/shippingType";
import {SHIPPING_CART_ITEMS_UPDATED} from "@/redux/reducers/responsive/actionsTypes";
import {SOLD_BY_MKP} from "@/utils/constants";

export function initializeSelectedShippingMethod(cartItems: CartItem[]): ThunkResult<SHIPPING_CART_ITEMS_UPDATE_TYPES> {
    return function (dispatch) {
        const data = {
            action : 'removeProductsShipping',
            items : cartItems?.filter(item => item.soldBy !== SOLD_BY_MKP).map(item => ({
                id: item.ean13,
                service: {code: ''}
            }))
        }
        ApiCaller.put("/WebUsers/" + getUserIdFromCookie() + "/Cart?View=shipping", data)
            .then(response => {
                dispatch({
                    type: SHIPPING_CART_ITEMS_UPDATED,
                    payload: {
                        cartObject: response.data,
                        billingFirstname: response.data.billingAddress.firstname,
                        billingPhone: response.data.billingAddress.phone,
                        billingLastname: response.data.billingAddress.lastname,
                        billingZipCode: response.data.billingAddress.zipCode,
                        billingCity: response.data.billingAddress.city,
                        billingStreetAddress: response.data.billingAddress.streetAddress,
                        billingStreetAddressComplement: response.data.billingAddress.streetAddressComplement,
                        billingCustomerAddressId: response.data.billingAddress.customerAddressId,
                        billingCivility: response.data.billingAddress.civility,
                        billingIsBilling: response.data.billingAddress.isBilling,
                        billingIsShipping: response.data.billingAddress.isShipping,
                        shippingFirstname: response.data.shippingAddress.firstname,
                        shippingPhone: response.data.shippingAddress.phone,
                        shippingLastname: response.data.shippingAddress.lastname,
                        shippingZipCode: response.data.shippingAddress.zipCode,
                        shippingCity: response.data.shippingAddress.city,
                        shippingStreetAddress: response.data.shippingAddress.streetAddress,
                        shippingStreetAddressComplement: response.data.shippingAddress.streetAddressComplement,
                        shippingCustomerAddressId: response.data.shippingAddress.customerAddressId,
                        shippingCivility: response.data.shippingAddress.civility,
                        shippingIsBilling: response.data.shippingAddress.isBilling,
                        shippingIsShipping: response.data.shippingAddress.isShipping
                    }
                });
            })
            .catch((error) => {
                //TODO SES thow exception
                console.log(error);
            })
    }
}